import React, { createContext, useContext, useState } from 'react';
import { supabase } from '../utils/supabase';


const DataContext = createContext();

export const DataProvider = ({ children }) => {
  
  const [restaurants, setRestaurants] = useState([]);
  const [categories, setCategories] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  
const fetchInitialData = async () => {
    try {
      setLoading(true);
      const { data: resData } = await supabase.from('restaurants').select(`
          id, name, percent_off, 
          restaurant_categories (categories (name))
      `);
      const { data: catData } = await supabase.from('categories').select('name');

      // Save to Context
      setRestaurants(resData || []);
      setCategories(catData || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <DataContext.Provider value={{ 
      restaurants, setRestaurants, 
      categories, setCategories,
      
      totalCount, setTotalCount,
      loading, setLoading,fetchInitialData
    }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);